// Module
var code = "<template>\n  Loading...\n</template>\n";
// Exports
export default code;